export function resolveHostUsingEnvironmentInfo(host: string): string {
    return process.env.REACT_APP_MSI_IDENTITY_HOST_LOCAL ?? host;
}
